import { CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { Routes } from './routes';
import { ContextApiProviders } from './context/globalContext';
import { NuqsAdapter } from 'nuqs/adapters/react-router';
import { GTMInitializer } from './components/atoms/gtmInitializer';
import { HotjarInitializer } from './components/atoms/hotjarInitializer';
import '../i18n';
import 'driver.js/dist/driver.css';
import './styles/driver-overrides.css';

export default function App() {
  return (
    <BrowserRouter>
      <NuqsAdapter>
        <ContextApiProviders>
          <GTMInitializer />
          <HotjarInitializer />
          <CssBaseline />
          <Routes />
        </ContextApiProviders>
      </NuqsAdapter>
    </BrowserRouter>
  );
}
